<template>
    <div>
        <fundraisers-filter></fundraisers-filter>
    </div>
</template>

<script>
export default {
    props: {
        authenticated: {
            type: Boolean,
            required: false
        },
    },

    created() {

    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// resources/js/views/fundraisers/components/index/PageFundraisers.vue